/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/ 		var executeModules = data[2];
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 		// add entry modules from loaded chunk to deferred list
/******/ 		deferredModules.push.apply(deferredModules, executeModules || []);
/******/
/******/ 		// run deferred modules when all chunks ready
/******/ 		return checkDeferredModules();
/******/ 	};
/******/ 	function checkDeferredModules() {
/******/ 		var result;
/******/ 		for(var i = 0; i < deferredModules.length; i++) {
/******/ 			var deferredModule = deferredModules[i];
/******/ 			var fulfilled = true;
/******/ 			for(var j = 1; j < deferredModule.length; j++) {
/******/ 				var depId = deferredModule[j];
/******/ 				if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 			}
/******/ 			if(fulfilled) {
/******/ 				deferredModules.splice(i--, 1);
/******/ 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 			}
/******/ 		}
/******/
/******/ 		return result;
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		33: 0
/******/ 	};
/******/
/******/ 	var deferredModules = [];
/******/
/******/ 	// script path function
/******/ 	function jsonpScriptSrc(chunkId) {
/******/ 		return __webpack_require__.p + "" + ({"0":"DynamicFeaturedCollection-StaticCart-StaticCollection-StaticProduct-StaticSearch","1":"vendors-DynamicFeaturedCollection-StaticCart-StaticCollection-StaticProduct-StaticSearch","2":"vendors-DynamicSearch-StaticCart-StaticSectionHeader","3":"DynamicSearch-StaticSectionHeader","4":"Account","5":"DynamicBlogPosts","6":"DynamicFeaturedCollection","7":"DynamicMenuList","8":"DynamicNewsletter","9":"DynamicProductExperience","10":"DynamicPromoBlocks","11":"DynamicRichText","12":"DynamicSearch","13":"DynamicVideo","14":"Glossary","15":"Page","16":"StaticAgeGate","17":"StaticArticle","18":"StaticBlog","19":"StaticCart","20":"StaticCollection","21":"StaticFilters","22":"StaticGiftcard","23":"StaticHighlightsBanners","24":"StaticPageContact","25":"StaticPageFaq","26":"StaticPageStoreLocations","27":"StaticProduct","28":"StaticRecentlyViewed","29":"StaticSearch","30":"StaticSectionFooter","31":"StaticSectionHeader","32":"StaticSlideshow","34":"vendors-Account","35":"vendors-StaticPageStoreLocations"}[chunkId]||chunkId) + ".bundle.js"
/******/ 	}
/******/
/******/ 	// script path function
/******/ 	function jsonpScriptSrc(chunkId) {
/******/ 	  var bundles = { '0': '//www.bccannabisstores.com/cdn/shop/t/3/assets/DynamicFeaturedCollection-StaticCart-StaticCollection-StaticProduct-StaticSearch.bundle.js?v=141686970427443239691707444442','1': '//www.bccannabisstores.com/cdn/shop/t/3/assets/vendors-DynamicFeaturedCollection-StaticCart-StaticCollection-StaticProduct-StaticSearch.bundle.js?v=170975508665289788461707444478','2': '//www.bccannabisstores.com/cdn/shop/t/3/assets/vendors-DynamicSearch-StaticCart-StaticSectionHeader.bundle.js?v=41750118139369695661707444549','3': '//www.bccannabisstores.com/cdn/shop/t/3/assets/DynamicSearch-StaticSectionHeader.bundle.js?v=158620803894021749501707444518','4': '//www.bccannabisstores.com/cdn/shop/t/3/assets/Account.bundle.js?v=39327072750847056141707444424','5': '//www.bccannabisstores.com/cdn/shop/t/3/assets/DynamicBlogPosts.bundle.js?v=147705199190809082081707444498','6': '//www.bccannabisstores.com/cdn/shop/t/3/assets/DynamicFeaturedCollection.bundle.js?v=159386964757027265001707444397','7': '//www.bccannabisstores.com/cdn/shop/t/3/assets/DynamicMenuList.bundle.js?v=150726541263284369291707444485','8': '//www.bccannabisstores.com/cdn/shop/t/3/assets/DynamicNewsletter.bundle.js?v=97242530443449460201707444424','9': '//www.bccannabisstores.com/cdn/shop/t/3/assets/DynamicProductExperience.bundle.js?v=29221662058372062851707444387','10': '//www.bccannabisstores.com/cdn/shop/t/3/assets/DynamicPromoBlocks.bundle.js?v=112465159347413329631707444519','11': '//www.bccannabisstores.com/cdn/shop/t/3/assets/DynamicRichText.bundle.js?v=131893851866870626631707444391','12': '//www.bccannabisstores.com/cdn/shop/t/3/assets/DynamicSearch.bundle.js?v=180450997099781678771707444360','13': '//www.bccannabisstores.com/cdn/shop/t/3/assets/DynamicVideo.bundle.js?v=43276066722074393571707444359','14': '//www.bccannabisstores.com/cdn/shop/t/3/assets/Glossary.bundle.js?v=150787155444152404341707444438','15': '//www.bccannabisstores.com/cdn/shop/t/3/assets/Page.bundle.js?v=107871167902563397691707444443','16': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticAgeGate.bundle.js?v=62648108386609079141707444465','17': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticArticle.bundle.js?v=116021267888629377651707444415','18': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticBlog.bundle.js?v=9083674280518716701707444424','19': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticCart.bundle.js?v=53943215364968194151707444411','20': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticCollection.bundle.js?v=22880793728001163861707444443','21': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticFilters.bundle.js?v=73500854697644942451707444360','22': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticGiftcard.bundle.js?v=169483208903343741941707444494','23': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticHighlightsBanners.bundle.js?v=156002195111603446651707444406','24': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticPageContact.bundle.js?v=58684795753369305941707444520','25': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticPageFaq.bundle.js?v=81703619477245406821707444359','26': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticPageStoreLocations.bundle.js?v=169399786637893110151707444530','27': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticProduct.bundle.js?v=177146355040634712141707444442','28': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticRecentlyViewed.bundle.js?v=151698752189969079311707444390','29': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticSearch.bundle.js?v=63728879048732274251707444509','30': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticSectionFooter.bundle.js?v=123611395723608871501707444433','31': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticSectionHeader.bundle.js?v=22887884849332846081707444542','32': '//www.bccannabisstores.com/cdn/shop/t/3/assets/StaticSlideshow.bundle.js?v=156614489961205647821707444359','34': '//www.bccannabisstores.com/cdn/shop/t/3/assets/vendors-Account.bundle.js?v=80741205373752307761707444424','35': '//www.bccannabisstores.com/cdn/shop/t/3/assets/vendors-StaticPageStoreLocations.bundle.js?v=28598681482030024461707444360' };
/******/ 	  return bundles[chunkId];
/******/ 	}
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var promises = [];
/******/
/******/
/******/ 		// JSONP chunk loading for javascript
/******/
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData !== 0) { // 0 means "already installed".
/******/
/******/ 			// a Promise means "currently loading".
/******/ 			if(installedChunkData) {
/******/ 				promises.push(installedChunkData[2]);
/******/ 			} else {
/******/ 				// setup Promise in chunk cache
/******/ 				var promise = new Promise(function(resolve, reject) {
/******/ 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 				});
/******/ 				promises.push(installedChunkData[2] = promise);
/******/
/******/ 				// start chunk loading
/******/ 				var script = document.createElement('script');
/******/ 				var onScriptComplete;
/******/
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.src = jsonpScriptSrc(chunkId);
/******/
/******/ 				// create error before stack unwound to get useful stacktrace later
/******/ 				var error = new Error();
/******/ 				onScriptComplete = function (event) {
/******/ 					// avoid mem leaks in IE.
/******/ 					script.onerror = script.onload = null;
/******/ 					clearTimeout(timeout);
/******/ 					var chunk = installedChunks[chunkId];
/******/ 					if(chunk !== 0) {
/******/ 						if(chunk) {
/******/ 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 							var realSrc = event && event.target && event.target.src;
/******/ 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 							error.name = 'ChunkLoadError';
/******/ 							error.type = errorType;
/******/ 							error.request = realSrc;
/******/ 							chunk[1](error);
/******/ 						}
/******/ 						installedChunks[chunkId] = undefined;
/******/ 					}
/******/ 				};
/******/ 				var timeout = setTimeout(function(){
/******/ 					onScriptComplete({ type: 'timeout', target: script });
/******/ 				}, 120000);
/******/ 				script.onerror = script.onload = onScriptComplete;
/******/ 				document.head.appendChild(script);
/******/ 			}
/******/ 		}
/******/ 		return Promise.all(promises);
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	var jsonpArray = window["wpJsonpPaskit"] = window["wpJsonpPaskit"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// add entry module to deferred list
/******/ 	deferredModules.push([198,36]);
/******/ 	// run deferred modules when ready
/******/ 	return checkDeferredModules();
/******/ })
/************************************************************************/
/******/ ({

/***/ 120:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 156:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(24);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./source/scripts/globals/jquery.js
// jQuery plugins expect to find a global `jQuery` object, so we
// need to attach it to the window.
//
// This is in its own file because we have to attach it before any
// other imports happen, but with ES6 modules, all `import`s have
// to be at the top.

window.jQuery = jquery_default.a;
window.$ = jquery_default.a;
// EXTERNAL MODULE: ./node_modules/flickity/js/index.js
var js = __webpack_require__(52);
var js_default = /*#__PURE__*/__webpack_require__.n(js);

// CONCATENATED MODULE: ./source/scripts/globals/flickity-ios-fix.js
 // This is required to fix an iOS10 bug for Flickity.
// It is our own implementation of the Flickity 2.0 fix found here: http://bit.ly/2kU4mKW

$(window).on('dragStart', function (event) {
  var $target = $(event.target);
  var $flickityEnabledEl = $target.closest('.flickity-enabled');

  if ($flickityEnabledEl.length) {
    var flickity = js_default.a.data($flickityEnabledEl[0]);
    window.removeEventListener('scroll', flickity);
  }
});
// EXTERNAL MODULE: ./node_modules/jquery-trend/jquery.trend.js
var jquery_trend = __webpack_require__(110);

// EXTERNAL MODULE: ./node_modules/jquery-revealer/jquery.revealer.js
var jquery_revealer = __webpack_require__(111);

// EXTERNAL MODULE: ./node_modules/@pixelunion/rimg-shopify/dist/index.es.js
var index_es = __webpack_require__(96);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(3);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/createClass.js
var createClass = __webpack_require__(4);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./source/scripts/helpers/index.js + 16 modules
var helpers = __webpack_require__(25);

// CONCATENATED MODULE: ./source/scripts/Sections.js



/*
  Commit SHA: 8b6d724 (May 7, 2019)

Pulled specific older version of this code from `empire-shopify` in Github.

*/

var Sections_Sections = /*#__PURE__*/function () {
  function Sections() {
    classCallCheck_default()(this, Sections);

    this.handlers = {};
    this.instances = {};
    this.options = {};
    this.lazyLoader = null;
    this._onSectionEvent = this._onSectionEvent.bind(this);
    document.addEventListener('shopify:section:load', this._onSectionEvent);
    document.addEventListener('shopify:section:unload', this._onSectionEvent);
    document.addEventListener('shopify:section:select', this._onSectionEvent);
    document.addEventListener('shopify:section:deselect', this._onSectionEvent);
    document.addEventListener('shopify:block:select', this._onSectionEvent);
    document.addEventListener('shopify:block:deselect', this._onSectionEvent);
  }
  /**
   * Stop listening for section events, and unbind all handlers.
   */


  createClass_default()(Sections, [{
    key: "unbind",
    value: function unbind() {
      document.removeEventListener('shopify:section:load', this._onSectionEvent);
      document.removeEventListener('shopify:section:unload', this._onSectionEvent);
      document.removeEventListener('shopify:section:select', this._onSectionEvent);
      document.removeEventListener('shopify:section:deselect', this._onSectionEvent);
      document.removeEventListener('shopify:block:select', this._onSectionEvent);
      document.removeEventListener('shopify:block:deselect', this._onSectionEvent); // Unload all instances

      for (var i = 0; i < this.instances.length; i++) {
        this._triggerInstanceEvent(this.instances[i], 'onSectionUnload');
      }

      this.handlers = {};
      this.options = {};
      this.lazyLoader.unload();
      this.lazyLoader = null;
      this.instances = {};
    }
    /**
     * Register a section handler.
     *
     * @param {string} type
     *        The section type to handle. The handler will be called for all
     *        sections with this type.
     *
     * @param {function} handler
     *        The handler function is passed information about a specific section
     *        instance. The handler is expected to return an object that will be
     *        associated with the section instance.
     *
     *        Section handlers are passed an object with the following parameters:
     *          {string} id
     *          An ID that maps to a specific section instance. Typically the
     *          section's filename for static sections, or a generated ID for
     *          dynamic sections.
     *
     *          {string} type
     *          The section type, as supplied when registered.
     *
     *          {Element} el
     *          The root DOM element for the section instance.
     *
     *          {Object} data
     *          Data loaded from the section script element. Defaults to an
     *          empty object.
     *
     *          {Function} postMessage
     *          A function that can be called to pass messages between sections.
     *          The function should be called with a message "name", and
     *          optionally some data.
     *
     * @param {object} options
     *
     * @param {boolean} options.lazy
     *         If true, sections will only be initialized after they intersect the viewport + 30% margin
     */

  }, {
    key: "register",
    value: function register(type, handler) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (this.handlers[type]) {
        console.warn("Sections: section handler already exists of type '".concat(type, "'."));
      } // Store the section handler


      this.handlers[type] = handler; // Store options

      this.options[type] = options; // Init sections for this type

      this._initSections(type);
    }
    /**
     * Initialize sections already on the page.
     */

  }, {
    key: "_initSections",
    value: function _initSections(type) {
      var _this = this;

      // Fetch all existing sections of our type on the page
      var dataEls = document.querySelectorAll("[data-section-type=\"".concat(type, "\"]"));
      if (!dataEls) return; // Create an instance for each section

      var _loop = function _loop(i) {
        var dataEl = dataEls[i];
        var el = dataEl.parentNode; // Get instance ID

        var idEl = el.querySelector('[data-section-id]');

        if (!idEl) {
          console.warn("Sections: unable to find section id for '".concat(type, "'."), el);
          return "continue";
        }

        var sectionId = idEl.getAttribute('data-section-id');

        if (!sectionId) {
          console.warn("Sections: unable to find section id for '".concat(type, "'."), el);
          return "continue";
        }

        if (_this.options[type] && _this.options[type].lazy) {
          if (_this.lazyLoader === null) {
            _this.lazyLoader = new helpers["c" /* LazyLoader */]();
          }

          _this.lazyLoader.add(el, function () {
            return _this._createInstance(sectionId, el);
          });
        } else {
          _this._createInstance(sectionId, el);
        }
      };

      for (var i = 0; i < dataEls.length; i++) {
        var _ret = _loop(i);

        if (_ret === "continue") continue;
      }
    }
  }, {
    key: "_onSectionEvent",
    value: function _onSectionEvent(event) {
      var el = event.target;
      var sectionId = event.detail.sectionId;
      var blockId = event.detail.blockId;
      var instance = this.instances[sectionId];

      switch (event.type) {
        case 'shopify:section:load':
          this._createInstance(sectionId, el);

          break;

        case 'shopify:section:unload':
          this._triggerInstanceEvent(instance, 'onSectionUnload', {
            el: el,
            id: sectionId
          });

          if (this.lazyLoader) {
            this.lazyLoader.remove(el);
          }

          delete this.instances[sectionId];
          break;

        case 'shopify:section:select':
          this._triggerInstanceEvent(instance, 'onSectionSelect', {
            el: el,
            id: sectionId
          });

          break;

        case 'shopify:section:deselect':
          this._triggerInstanceEvent(instance, 'onSectionDeselect', {
            el: el,
            id: sectionId
          });

          break;

        case 'shopify:block:select':
          this._triggerInstanceEvent(instance, 'onSectionBlockSelect', {
            el: el,
            id: blockId
          });

          break;

        case 'shopify:block:deselect':
          this._triggerInstanceEvent(instance, 'onSectionBlockDeselect', {
            el: el,
            id: blockId
          });

          break;
      }
    }
  }, {
    key: "_triggerInstanceEvent",
    value: function _triggerInstanceEvent(instance, eventName) {
      if (instance && instance[eventName]) {
        for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        instance[eventName].apply(instance, args);
      }
    }
  }, {
    key: "_postMessage",
    value: function _postMessage(name, data) {
      var _this2 = this;

      Object.keys(this.instances).forEach(function (id) {
        _this2._triggerInstanceEvent(_this2.instances[id], 'onSectionMessage', name, data);
      });
    }
  }, {
    key: "_createInstance",
    value: function _createInstance(id, el) {
      var typeEl = el.querySelector('[data-section-type]');
      if (!typeEl) return;
      var type = typeEl.getAttribute('data-section-type');
      if (!type) return;
      var handler = this.handlers[type];
      if (!handler) return console.warn("Sections: unable to find section handler for type '".concat(type, "'."));

      var data = this._loadData(el);

      var postMessage = this._postMessage.bind(this);

      this.instances[id] = handler({
        id: id,
        type: type,
        el: el,
        data: data,
        postMessage: postMessage
      });
    }
  }, {
    key: "_loadData",
    value: function _loadData(el) {
      var dataEl = el.querySelector('[data-section-data]');
      if (!dataEl) return {}; // Load data from attribute, or innerHTML

      var data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;

      try {
        return JSON.parse(data);
      } catch (error) {
        console.warn("Sections: invalid section data found. ".concat(error.message));
        return {};
      }
    }
  }]);

  return Sections;
}();


// CONCATENATED MODULE: ./source/scripts/Theme.js
// Global imports

 // jQuery plugins

 // eslint-disable-line

 // eslint-disable-line
// Responsive Images

 // eslint-disable-line
// Section imports

 // Helpers



var Theme_initTheme = function initTheme() {
  index_es["a" /* default */].init('[data-rimg="lazy"]', {
    round: 1
  });
  var sections = new Sections_Sections(); // NOTE: Static Age Gate hides all content until age is verified.
  // Opinionated order of imports for sections, static first, then dynamic

  sections.register('static-age-gate', function (section) {
    return __webpack_require__.e(/* import() | StaticAgeGate */ 16).then(__webpack_require__.bind(null, 271)).then(function (_ref) {
      var StaticAgeGate = _ref.default;
      return new StaticAgeGate(section);
    });
  });
  sections.register('static-article', function (section) {
    return __webpack_require__.e(/* import() | StaticArticle */ 17).then(__webpack_require__.bind(null, 272)).then(function (_ref2) {
      var StaticArticle = _ref2.default;
      return new StaticArticle(section);
    });
  });
  sections.register('static-blog', function (section) {
    return __webpack_require__.e(/* import() | StaticBlog */ 18).then(__webpack_require__.bind(null, 273)).then(function (_ref3) {
      var StaticBlog = _ref3.default;
      return new StaticBlog(section);
    });
  });
  sections.register('static-cart', function (section) {
    return Promise.all(/* import() | StaticCart */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, 296)).then(function (_ref4) {
      var StaticCart = _ref4.default;
      return new StaticCart(section);
    });
  });
  sections.register('static-collection', function (section) {
    return Promise.all(/* import() | StaticCollection */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(20)]).then(__webpack_require__.bind(null, 274)).then(function (_ref5) {
      var StaticCollection = _ref5.default;
      return new StaticCollection(section);
    });
  });
  sections.register('static-filters', function (section) {
    return __webpack_require__.e(/* import() | StaticFilters */ 21).then(__webpack_require__.bind(null, 275)).then(function (_ref6) {
      var StaticFilters = _ref6.default;
      return new StaticFilters(section);
    });
  });
  sections.register('static-footer', function (section) {
    return __webpack_require__.e(/* import() | StaticSectionFooter */ 30).then(__webpack_require__.bind(null, 276)).then(function (_ref7) {
      var StaticSectionFooter = _ref7.default;
      return new StaticSectionFooter(section);
    });
  });
  sections.register('static-giftcard', function (section) {
    return __webpack_require__.e(/* import() | StaticGiftcard */ 22).then(__webpack_require__.bind(null, 277)).then(function (_ref8) {
      var StaticGiftcard = _ref8.default;
      return new StaticGiftcard(section);
    });
  });
  sections.register('static-header', function (section) {
    return Promise.all(/* import() | StaticSectionHeader */[__webpack_require__.e(2), __webpack_require__.e(3), __webpack_require__.e(31)]).then(__webpack_require__.bind(null, 295)).then(function (_ref9) {
      var StaticSectionHeader = _ref9.default;
      return new StaticSectionHeader(section);
    });
  });
  sections.register('static-highlights-banners', function (section) {
    return __webpack_require__.e(/* import() | StaticHighlightsBanners */ 23).then(__webpack_require__.bind(null, 278)).then(function (_ref10) {
      var StaticHighlightsBanners = _ref10.default;
      return new StaticHighlightsBanners(section);
    });
  });
  sections.register('static-page-contact', function (section) {
    return __webpack_require__.e(/* import() | StaticPageContact */ 24).then(__webpack_require__.bind(null, 279)).then(function (_ref11) {
      var StaticPageContact = _ref11.default;
      return new StaticPageContact(section);
    });
  });
  sections.register('static-page-faq', function (section) {
    return __webpack_require__.e(/* import() | StaticPageFaq */ 25).then(__webpack_require__.bind(null, 280)).then(function (_ref12) {
      var StaticPageFaq = _ref12.default;
      return new StaticPageFaq(section);
    });
  });
  sections.register('static-page-store-locations', function (section) {
    return Promise.all(/* import() | StaticPageStoreLocations */[__webpack_require__.e(35), __webpack_require__.e(26)]).then(__webpack_require__.bind(null, 281)).then(function (_ref13) {
      var StaticPageStoreLocations = _ref13.default;
      return new StaticPageStoreLocations(section);
    });
  });
  sections.register('static-product', function (section) {
    return Promise.all(/* import() | StaticProduct */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(27)]).then(__webpack_require__.bind(null, 298)).then(function (_ref14) {
      var StaticProduct = _ref14.default;
      return new StaticProduct(section);
    });
  });
  sections.register('static-recently-viewed', function (section) {
    return __webpack_require__.e(/* import() | StaticRecentlyViewed */ 28).then(__webpack_require__.bind(null, 282)).then(function (_ref15) {
      var StaticRecentlyViewed = _ref15.default;
      return new StaticRecentlyViewed(section);
    });
  });
  sections.register('static-search', function (section) {
    return Promise.all(/* import() | StaticSearch */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(29)]).then(__webpack_require__.bind(null, 283)).then(function (_ref16) {
      var StaticSearch = _ref16.default;
      return new StaticSearch(section);
    });
  });
  sections.register('static-slideshow', function (section) {
    return __webpack_require__.e(/* import() | StaticSlideshow */ 32).then(__webpack_require__.bind(null, 284)).then(function (_ref17) {
      var StaticSlideshow = _ref17.default;
      return new StaticSlideshow(section);
    });
  });
  sections.register('dynamic-blog-posts', function (section) {
    return __webpack_require__.e(/* import() | DynamicBlogPosts */ 5).then(__webpack_require__.bind(null, 285)).then(function (_ref18) {
      var DynamicBlogPosts = _ref18.default;
      return new DynamicBlogPosts(section);
    });
  });
  sections.register('dynamic-featured-collection', function (section) {
    return Promise.all(/* import() | DynamicFeaturedCollection */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, 286)).then(function (_ref19) {
      var DynamicFeaturedCollection = _ref19.default;
      return new DynamicFeaturedCollection(section);
    });
  });
  sections.register('dynamic-menu-list', function (section) {
    return __webpack_require__.e(/* import() | DynamicMenuList */ 7).then(__webpack_require__.bind(null, 287)).then(function (_ref20) {
      var DynamicMenuList = _ref20.default;
      return new DynamicMenuList(section);
    });
  });
  sections.register('dynamic-product-experience', function (section) {
    return __webpack_require__.e(/* import() | DynamicProductExperience */ 9).then(__webpack_require__.bind(null, 288)).then(function (_ref21) {
      var DynamicProductExperience = _ref21.default;
      return new DynamicProductExperience(section);
    });
  });
  sections.register('dynamic-promo-grid', function (section) {
    return __webpack_require__.e(/* import() | DynamicPromoBlocks */ 10).then(__webpack_require__.bind(null, 289)).then(function (_ref22) {
      var DynamicPromoBlocks = _ref22.default;
      return new DynamicPromoBlocks(section);
    });
  });
  sections.register('dynamic-rich-text', function (section) {
    return __webpack_require__.e(/* import() | DynamicRichText */ 11).then(__webpack_require__.bind(null, 290)).then(function (_ref23) {
      var DynamicRichText = _ref23.default;
      return new DynamicRichText(section);
    });
  });
  sections.register('dynamic-search', function (section) {
    return Promise.all(/* import() | DynamicSearch */[__webpack_require__.e(2), __webpack_require__.e(3), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, 291)).then(function (_ref24) {
      var DynamicSearch = _ref24.default;
      return new DynamicSearch(section);
    });
  });
  sections.register('dynamic-video', function (section) {
    return __webpack_require__.e(/* import() | DynamicVideo */ 13).then(__webpack_require__.bind(null, 292)).then(function (_ref25) {
      var DynamicVideo = _ref25.default;
      return new DynamicVideo(section);
    });
  });
  sections.register('pxs-newsletter', function (section) {
    return __webpack_require__.e(/* import() | DynamicNewsletter */ 8).then(__webpack_require__.bind(null, 293)).then(function (_ref26) {
      var DynamicNewsletter = _ref26.default;
      return new DynamicNewsletter(section);
    });
  });
  /*
    Template imports
  */

  var bodyClasses = document.body.classList;

  if (bodyClasses.contains('template-customers/account') || bodyClasses.contains('template-customers/account.order')) {
    Promise.all(/* import() | Account */[__webpack_require__.e(34), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, 297)).then(function (_ref27) {
      var Account = _ref27.default;
      return new Account();
    });
  }

  if (bodyClasses.contains('template-page')) {
    __webpack_require__.e(/* import() | Page */ 15).then(__webpack_require__.bind(null, 294)).then(function (_ref28) {
      var Page = _ref28.default;
      return new Page();
    });
  }

  if (bodyClasses.contains('template-page.glossary')) {
    __webpack_require__.e(/* import() | Glossary */ 14).then(__webpack_require__.bind(null, 299)).then(function (_ref29) {
      var Glossary = _ref29.default;
      return new Glossary();
    });
  }

  new helpers["d" /* ManageCartQuantities */]();
};

Theme_initTheme();

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ CheckoutValidator_CheckoutValidator; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ Images_Images; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ LazyLoader_LazyLoader; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ ManageCartQuantities_ManageCartQuantities; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* reexport */ trapFocus; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ removeTrapFocus; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ checkIfCartsEmpty; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ clearCart; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* reexport */ totalGramEquivalency; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ cdfUpdateQuantities; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ cdfQuantityTotal; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ getHeaderOffset; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ getLiquidVars; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ formatMoney; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ isMoney; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ numberInputValidation; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ scrollLeft; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* reexport */ useIntegrationAPI; });

// UNUSED EXPORTS: getCart, createAccessibleRedirect, dispatchBrowserEvent

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(3);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/createClass.js
var createClass = __webpack_require__(4);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./source/scripts/Forms.js
var Forms = __webpack_require__(53);

// CONCATENATED MODULE: ./source/scripts/helpers/CheckoutValidator.js




var CheckoutValidator_CheckoutValidator = /*#__PURE__*/function () {
  function CheckoutValidator($el, $form) {
    classCallCheck_default()(this, CheckoutValidator);

    this.$el = $el;
    this.$form = $form;
    this.$checkoutButton = $el.find('[name="checkout"]');
    this.siteData = getLiquidVars('[data-site-data]');
    this.restrictionAmountMax = this.siteData.restriction_amount_max;
    this.restrictedAge = this.siteData.age;
    this.isUnrestricted = this.siteData.is_unrestricted;
    var validationRules = {
      rules: {
        ageValidationCheckbox: 'required',
        cartGramRestriction: {
          max: {
            param: this.restrictionAmountMax
          },
          number: true
        },
        privacyConsentCheckbox: 'required',
        termsCheckbox: 'required'
      }
    };
    this.forms = new Forms["a" /* default */](this.$form, validationRules);

    this._bindEvents();
  }

  createClass_default()(CheckoutValidator, [{
    key: "unload",
    value: function unload() {
      this.$form.off('.cart');
      this.forms.unload();
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;

      this.$el.on('restriction:update', function () {
        _this._checkValidity();
      });
      this.$form.on('change.cart', '[name="ageValidationCheckbox"], [name="termsCheckbox"], [name="privacyConsentCheckbox"]', function () {
        _this._checkValidity();
      });
    }
  }, {
    key: "_checkValidity",
    value: function _checkValidity() {
      if (this.$form.valid()) {
        this.$checkoutButton.removeClass('disabled').removeAttr('disabled');
      } else {
        this.$checkoutButton.addClass('disabled').attr('disabled', true);
      }
    }
  }]);

  return CheckoutValidator;
}();
// CONCATENATED MODULE: ./source/scripts/helpers/Images.js


var Images_Images = /*#__PURE__*/function () {
  function Images() {
    classCallCheck_default()(this, Images);
  }

  createClass_default()(Images, [{
    key: "preload",
    value:
    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */
    function preload(images, size) {
      if (typeof images === 'string') {
        images = [images];
      }

      for (var i = 0; i < images.length; i++) {
        this.loadImage(this.getSizedImageUrl(images[i], size));
      }
    }
    /**
     * Loads and caches an image in the browsers cache.
     *
     * @param {string} path - An image url
     */

  }, {
    key: "loadImage",
    value: function loadImage(path) {
      return new Image().src = path;
    }
    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */

  }, {
    key: "getSizedImageUrl",
    value: function getSizedImageUrl() {
      var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var size = arguments.length > 1 ? arguments[1] : undefined;

      if (!size) {
        return null;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
        return this.removeProtocol("".concat(prefix[0], "_").concat(size).concat(suffix));
      }

      console.warn("No ".concat(size, " found for '").concat(src));
      return null;
    }
  }, {
    key: "removeProtocol",
    value: function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  }]);

  return Images;
}();
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__(23);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./source/scripts/helpers/LazyLoader.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Allows a callback to be run once, when a target intersects the viewport.
 * @constructor
 * @param {HTMLElement} target Element to track
 * @param {Function} callback Function to execute when target enters viewport (only executed once)
 * @param {Object} [options] options with which to construct the IntersectionObserver
 * @param {string} [options.rootMargin='30%'] A string which specifies a set of offsets to add to the root's bounding_box when calculating intersections.
 * @param {number} [options.threshold=0] Ratio of intersection required to trigger callback
 */
var LazyLoader_LazyLoader = /*#__PURE__*/function () {
  function LazyLoader(target, callback, options) {
    classCallCheck_default()(this, LazyLoader);

    var defaultOptions = {
      rootMargin: '30%',
      threshold: 0
    };
    this.callback = callback;
    this._runCallback = this._runCallback.bind(this);
    this.observer = new IntersectionObserver(this._runCallback, _objectSpread(_objectSpread({}, defaultOptions), options));
    this.observer.observe(target);
  }
  /**
   * Runs the callback if first entry becomes intersecting, then unloads the LazyLoader
   * @_runCallback
   * @param {IntersectionObserverEntry[]} entries Entry to check - all but the
   * first element will be ignored.
   */


  createClass_default()(LazyLoader, [{
    key: "_runCallback",
    value: function _runCallback(entries) {
      // do nothing unless target moved into state of intersection
      if (entries[0].isIntersecting === true) {
        this.unload();
        this.callback();
      }
    }
    /**
     * Disconnects IntersectionObserver if active
     * @unload
     */

  }, {
    key: "unload",
    value: function unload() {
      this.observer.disconnect();
    }
  }]);

  return LazyLoader;
}();
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(56);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(51);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// CONCATENATED MODULE: ./source/scripts/helpers/cart.js
function checkIfCartsEmpty(callback) {
  var cartsBeenCleared = false;
  return function (event) {
    if (cartsBeenCleared) {
      cartsBeenCleared = false;
      return;
    }

    event.preventDefault();
    callback.apply(this, arguments);
    cartsBeenCleared = true;
    $(this).trigger(event.type);
  };
}
function clearCart() {
  return new Promise(function (resolve) {
    resolve(Shopify.clear(function () {
      return (// NOTE: Passing null as callback otherwise alert() is displayed. :(
        null
      );
    }));
  });
}
var getCart = function getCart() {
  return $.getJSON('/cart.js');
};
// CONCATENATED MODULE: ./source/scripts/helpers/getLiquidVars.js
/**
 * A helper to return a JSON object of Liquid variables.
 * @param {selector}
 * @returns {JSON}
 */
function getLiquidVars() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var dataEl = document.querySelector(selector);

  try {
    return JSON.parse(dataEl.innerHTML);
  } catch (error) {
    return null;
  }
}
// CONCATENATED MODULE: ./source/scripts/helpers/ManageCartQuantities.js







/**
 * Manages cart quantities, and resolves CDF quantities
 */

var ManageCartQuantities_ManageCartQuantities = /*#__PURE__*/function () {
  function ManageCartQuantities() {
    classCallCheck_default()(this, ManageCartQuantities);

    this.$body = $(document.body);
    var data = getLiquidVars('[data-site-data]');
    this.cdfItem = data.cdf;
    this.context = data.context;

    if (this.cdfItem.variants === undefined) {
      throw new Error('Container deposit fee product is not available');
    }

    this.feesItems = this._setupFeesItems(this.cdfItem.variants);
    this.events = [this.$body.on('updateCartQuantities', this._updateQuantities.bind(this))];
  }
  /**
   * Updates cart quantities, accounting for quantities
   * already in cart.
   *
   * @param {object} data
   *  variantId: of item to add to cart
   *  quantity: to add to cart
   *
   * @param {object} callbacks
   *  doneCallback: fired on successful cart update
   *  failCallback: fired on cart update failure
   */


  createClass_default()(ManageCartQuantities, [{
    key: "_updateQuantities",
    value: function () {
      var _updateQuantities2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(event, options) {
        var _this = this;

        var _options$callbacks, doneCallback, failCallback, request, _this$_formatUpdateRe, updates, isError, timeoutLength;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getCart();

              case 2:
                this.cart = _context.sent;
                this.cartItems = this._formatCart(this.cart.items);

                this._formatFeesItems(this.cart);

                _options$callbacks = options.callbacks, doneCallback = _options$callbacks.doneCallback, failCallback = _options$callbacks.failCallback;
                request = options.data;
                _this$_formatUpdateRe = this._formatUpdateRequest(options.data), updates = _this$_formatUpdateRe.updates, isError = _this$_formatUpdateRe.isError;

                if (!isError) {
                  _context.next = 12;
                  break;
                }

                timeoutLength = 500;
                setTimeout(function () {
                  var manualResponse = {
                    responseText: {
                      description: _this.context.atc.quantity_unavailable
                    }
                  };

                  if (failCallback) {
                    request.currentQuantity = _this.cartItems[options.data.id] ? _this.cartItems[options.data.id].quantity : 0;
                    failCallback(manualResponse, request, options.$elements);
                  }
                }, timeoutLength);
                return _context.abrupt("return");

              case 12:
                $.ajax({
                  type: 'POST',
                  url: '/cart/update.js',
                  data: {
                    updates: updates
                  },
                  dataType: 'json'
                }).done(function (response) {
                  _this.cart = response;
                  _this.cartItems = _this._formatCart(response.items);

                  _this._formatFeesItems(response);

                  if (doneCallback) {
                    doneCallback(response, request, options.$elements);
                  }
                }).fail(function (response) {
                  if (failCallback) {
                    failCallback(response, request, options.$elements);
                  }
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _updateQuantities(_x, _x2) {
        return _updateQuantities2.apply(this, arguments);
      }

      return _updateQuantities;
    }()
    /**
     * Format variant ID/quantity data for use
     * with Shopify's AJAX API "update" endpoint
     *
     * @param {object} data
     * @returns {object} formatted ATC object
     *
     */

  }, {
    key: "_formatUpdateRequest",
    value: function _formatUpdateRequest(data) {
      var action = data.action,
          cdf = data.cdf,
          id = data.id,
          maxQuantity = data.maxQuantity,
          quantity = data.quantity;
      var isError = false;
      var currentQuantity = 0;
      var requestedQuantity = quantity;

      if (this.cartItems[id]) {
        currentQuantity = this.cartItems[id].quantity;
      } // Default functionality updates quantity. If we want to
      // add quantity, we must alter the request to add the
      // current cart quantity for the item.


      if (action === 'add') {
        requestedQuantity = quantity + currentQuantity;
      }

      if (requestedQuantity > maxQuantity) {
        isError = true;
      }

      data.quantity = requestedQuantity;

      var updates = defineProperty_default()({}, id, data.quantity); // Add CDF to the request if it exists


      if (this.feesItems[cdf]) {
        updates = this._addCdfToRequest(updates, data);
      }

      return {
        updates: updates,
        isError: isError
      };
    }
    /**
     * Format cart contents for easier product lookups
     *
     * @param {object} cart
     * @returns {object} cart items accessed via ID
     *  and containing current cart quantity and update
     *  key
     *
     */

  }, {
    key: "_formatCart",
    value: function _formatCart(cartItems) {
      var items = {};

      for (var i = 0; i < cartItems.length; i++) {
        var item = cartItems[i];
        items[item.id] = {
          quantity: item.quantity,
          key: item.id
        };
      }

      return items;
    }
    /**
     * Chains as CDF product to the cart update request
     *
     * @param {object} updates original cart update request
     * @param {object} data original request info
     * @returns {object} altered request object containing CDF
     */

  }, {
    key: "_addCdfToRequest",
    value: function _addCdfToRequest(updates, data) {
      var _this$_getFeesItemId = this._getFeesItemId(data.cdf, data.sku),
          id = _this$_getFeesItemId.id,
          quantity = _this$_getFeesItemId.quantity;

      var finalQuantity = data.quantity * data.consumerUnits + quantity;

      var cdfRequest = defineProperty_default()({}, id, finalQuantity);

      this.feesItems[data.cdf].quantity = this.feesItems[data.cdf].quantity + finalQuantity;
      return $.extend(null, updates, cdfRequest);
    }
    /**
     * Gets ID or key of fees item to ensure correct CDF cart
     * line item is being adjusted
     *
     * @param {string} cdfSku SKU of CDF product associated with requested item
     * @param {string} sku SKU of requested item
     */

  }, {
    key: "_getFeesItemId",
    value: function _getFeesItemId(cdfSku, sku) {
      var id = false;
      var quantity = 0;
      var feesItems = this.cart.items.filter(function (item) {
        return item.sku === cdfSku;
      });

      if (this.feesItems[sku]) {
        id = this.feesItems[sku].key;
      } else if (this.feesItems[cdfSku]) {
        id = this.feesItems[cdfSku].key;
        quantity = feesItems[0] ? feesItems[0].quantity : 0;
      }

      return {
        id: id,
        quantity: quantity
      };
    }
    /**
     * Initial fees tracking object setup
     *
     * @param {array} variants Standard variant array from Shopify
     */

  }, {
    key: "_setupFeesItems",
    value: function _setupFeesItems(variants) {
      var items = {};

      for (var i = 0; i < variants.length; i++) {
        var item = variants[i];
        items[item.sku] = {
          quantity: 0,
          key: item.id
        };
      }

      return items;
    }
    /**
     * Updates fees tracking object based on cart contents
     *
     * @param {object} cart Standard cart object from Shopify
     */

  }, {
    key: "_formatFeesItems",
    value: function _formatFeesItems(cart) {
      // Reset fees items
      // this.feesItems = this._setupFeesItems(this.cdfItem.variants);
      // Pare down cart item array to only contain fee items
      var itemsFilteredForFees = cart.items.filter(function (item) {
        return item.handle === 'cdf';
      }); // Loop over fee items array

      var feesItems = {};

      for (var i = 0; i < itemsFilteredForFees.length; i++) {
        var item = itemsFilteredForFees[i]; // Create object of fee item/key pairs, linking beverage item
        // skus to fee item cart keys

        if (item.properties && item.properties.sku) {
          feesItems[item.properties.sku] = item.key;
        }
      } // linking beverage item skus to fee item cart keys within
      // class fee tracking object


      for (var _i = 0; _i < cart.items.length; _i++) {
        var _item = cart.items[_i];

        if (feesItems[_item.sku] && _item.handle !== 'cdf') {
          this.feesItems[_item.sku] = {
            quantity: _item.quantity * _item.properties.consumer_units,
            key: feesItems[_item.sku]
          };
        }
      }
    }
  }]);

  return ManageCartQuantities;
}();
// CONCATENATED MODULE: ./source/scripts/helpers/a11y.js
/**
 * Traps the focus in a particular container
 *
 * @param {object} options - Options to be used
 * @param {jQuery} options.$container - Container to trap focus within
 * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
 * @param {string} options.namespace - Namespace used for new focus event handler
 */
function trapFocus(options) {
  var eventName = options.namespace ? "focusin.".concat(options.namespace) : 'focusin';

  if (!options.$elementToFocus) {
    options.$elementToFocus = options.$container;
  }

  options.$container.attr('tabindex', '-1');
  options.$elementToFocus.focus();
  $(document).on(eventName, function (evt) {
    if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
      options.$container.focus();
    }
  });
}
/**
 * Removes the trap of focus in a particular container
 *
 * @param {object} options - Options to be used
 * @param {jQuery} options.$container - Container to trap focus within
 * @param {string} options.namespace - Namespace used for new focus event handler
 */


function removeTrapFocus(options) {
  var eventName = options.namespace ? "focusin.".concat(options.namespace) : 'focusin';

  if (options.$container && options.$container.length) {
    options.$container.removeAttr('tabindex');
  }

  $(document).off(eventName);
}
/**
 * Adds focus if user presses a keyboard key
 *
 * @param {object} keycode - Key code to be used (in this case, tab (9))
 */


function handleFirstTab(event) {
  if (event.keyCode === 9) {
    document.body.classList.add('user-is-tabbing');
    window.removeEventListener('keydown', handleFirstTab);
  }
}

window.addEventListener('keydown', handleFirstTab);

// CONCATENATED MODULE: ./source/scripts/helpers/cartTotalGramEquivalency.js
/**
 * Display the error state when user is over restricted amount.
 * @param {object} products - Items property from the Shopify Cart object.
 *
 * @return {number} total - Total amount of cannabis gram equivalency found in provided array
 */
var totalGramEquivalency = function totalGramEquivalency() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var itemTotals = []; // NOTE: Build array of amounts

  items.forEach(function (item) {
    if (item.properties && item.properties.gram_equivalency) {
      var itemGramAmount = item.properties.gram_equivalency;
      var itemQyt = item.quantity;
      var itemAmount = itemGramAmount * itemQyt;
      itemTotals.push(itemAmount);
    }
  }); // NOTE: Add array elements amounts

  var totalAmount = itemTotals.reduce(function (acc, val) {
    return acc + val;
  }, 0); // NOTE: Trim float lengths to fixed length

  var totalAmountTrimmed = totalAmount.toFixed(2); // NOTE: Convert back to number as `toFixed` will return string.

  var totalAmountType = parseFloat(totalAmountTrimmed);
  return totalAmountType;
};
/* harmony default export */ var cartTotalGramEquivalency = (totalGramEquivalency);
// CONCATENATED MODULE: ./source/scripts/helpers/cdf.js
var cdf_settings = {
  cdfContainer: '[data-cart-cdf-container]',
  cdfLineSelector: '[data-cart-cdf]',
  cdfQuantitySelector: '[data-cart-cdf-quantity]',
  visibleClass: 'visible'
};
/**
 * Performs aesthetic updates of CDF lines in the subtotal area
 *
 * @param {cart} object = cart object
 */

var cdfUpdateQuantities = function cdfUpdateQuantities(cart) {
  var cdfContainer = document.querySelector(cdf_settings.cdfContainer);
  var cdfContainerVisibleClass = cdf_settings.visibleClass;
  var cdfLines = document.querySelectorAll(cdf_settings.cdfLineSelector);
  var cdfLineVisibleClass = cdf_settings.visibleClass;
  var feeItems = cart.items.filter(function (item) {
    return item.product_type.toLowerCase() === 'fee';
  }).map(function (item) {
    return {
      sku: item.sku,
      quantity: item.quantity
    };
  });
  var cdfLineQuantities = {};
  var hasCDF = false;

  for (var i = 0; i < feeItems.length; i++) {
    var item = feeItems[i];

    if (!cdfLineQuantities[item.sku]) {
      cdfLineQuantities[item.sku] = 0;
    }

    cdfLineQuantities[item.sku] += item.quantity;

    if (cdfLineQuantities[item.sku] > 0) {
      hasCDF = true;
    }
  }

  for (var _i = 0; _i < cdfLines.length; _i++) {
    var cdfLine = cdfLines[_i];
    var sku = cdfLine.dataset.cartCdf;
    var quantity = cdfLineQuantities[sku] || 0;
    cdfContainer.classList.toggle(cdfContainerVisibleClass, hasCDF);
    cdfLine.classList.toggle(cdfLineVisibleClass, quantity > 0);
    cdfLine.querySelector(cdf_settings.cdfQuantitySelector).innerHTML = quantity;
  }
};

var cdfQuantityTotal = function cdfQuantityTotal(cart) {
  var cdfProducts = cart.items.filter(function (item) {
    return item.product_type.toLowerCase() === 'fee';
  });
  return cdfProducts.reduce(function (total, item) {
    return total + item.quantity;
  }, 0);
};


// CONCATENATED MODULE: ./source/scripts/helpers/createAccessibleRedirect.js
/**
 * Get the offset of the header
 *
 * @param {string} Href value for anchor
 * @param {string} Id attribute for anchor
 * @param {string} Text for anchor
 * @returns {HTMLElement}
 */
function createAccessibleRedirect() {
  var hrefValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#';
  var elementId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'redirect-anchor';
  var anchorText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  $("<a/>").attr({
    href: hrefValue,
    id: elementId
  }).css({
    visibility: 'hidden'
  }).text(anchorText).appendTo('body').get(0).click();
}
// CONCATENATED MODULE: ./source/scripts/helpers/dispatchBrowserEvent.js
/**
 * Hooking into the Shopify Checkout page JS relies on native browser events
 * rather than jQuery events.
 *
 * @param {jQuery} $element element to fire event on
 * @param {String} eventName event type ('click', 'blur'....)
 */
function dispatchBrowserEvent($element, eventName) {
  if ('createEvent' in document) {
    var evt = document.createEvent('HTMLEvents');
    evt.initEvent(eventName, true, true);
    $element[0].dispatchEvent(evt);
  } else {
    $element[0].fireEvent("on".concat(eventName));
  }
}
// CONCATENATED MODULE: ./source/scripts/helpers/getHeaderOffset.js
/**
 * Get the offset of the header
 *
 * @param {HTMLElement} header
 * @param {Boolean} withAnnouncementBar
 * @returns {number}
 */
function getHeaderOffset(header) {
  var withAnnouncementBar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var offset = 0; // If is not sticky header, then DOM can be trusted to return values

  var _header$getBoundingCl = header.getBoundingClientRect(),
      bottom = _header$getBoundingCl.bottom;

  offset = bottom > 0 ? bottom : 0;

  if (withAnnouncementBar) {
    offset += parseInt(header.style.top, 10) || 0;
  }

  return offset;
}
// CONCATENATED MODULE: ./source/scripts/helpers/liquidMoneyHelpers.js
var moneyKeys = ['subtotal_price', 'total_price', 'price', 'line_price', 'tax_price', 'total_tax', 'total_discount', 'total_discounts', 'total_line_items_price', 'total_price_usd', 'total_tip_received', 'total_spent', 'discounted_price'];

function isMoney(key) {
  return moneyKeys.indexOf(key) !== -1;
}

function formatMoney(money) {
  var cents = "".concat(money).indexOf('.') !== -1 ? money * 100 : money;
  var formatter = new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2
  });
  return formatter.format(cents / 100);
}


// CONCATENATED MODULE: ./source/scripts/helpers/numberInputValidation.js
/* eslint-disable no-magic-numbers */
function numberInputValidation(event) {
  var which = event.which;
  var isShortcut = event.altKey || event.ctrlKey || event.metaKey;
  var allowedKeys = [8, 9, 13, 37, 38, 39, 40]; // delete, tab, return, arrows
  //Bail if allowed key or shortcut

  if (allowedKeys.indexOf(which) !== -1 || isShortcut) {
    return true;
  } // Return true if input is number keys or number pad


  return which >= 48 && which <= 57 || which >= 96 && which <= 105;
}


// CONCATENATED MODULE: ./source/scripts/helpers/scrollLeft.js
function scrollLeft($el) {
  var $container = $el.parent();
  var amount = 2;
  $container.animate({
    scrollLeft: $el.offset().left - $el.width() / amount - $container.width() / amount
  });
}
// EXTERNAL MODULE: ./node_modules/@pixelunion/bccs-utils/dist/index.js
var dist = __webpack_require__(97);

// CONCATENATED MODULE: ./source/scripts/helpers/use-integration-api.js


function useIntegrationAPI() {
  var _getLiquidVars = getLiquidVars('[data-integration]'),
      settings = _getLiquidVars.settings;

  var environment = settings.environment,
      customerId = settings.customerId,
      domain = settings.domain,
      hmac = settings.hmac;
  return new dist["IntegrationAPI"]({
    environment: environment,
    customerId: customerId,
    domain: domain,
    hmac: hmac
  });
}
// CONCATENATED MODULE: ./source/scripts/helpers/index.js

















/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Forms; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var jquery_validation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(112);
/* harmony import */ var jquery_validation__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(jquery_validation__WEBPACK_IMPORTED_MODULE_2__);




var Forms = /*#__PURE__*/function () {
  function Forms($el, validationRules) {
    var selector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.form-field-input';

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Forms);

    this.$el = $el;
    this.filledClass = 'form-field-filled';
    this.fieldSelector = selector;
    this.validationRules = validationRules || null;
    this._toggleFilled = this._toggleFilled.bind(this);
    this.$el.on('focus.forms', this.fieldSelector, this._toggleFilled);
    this.$el.on('blur.forms', this.fieldSelector, this._toggleFilled);

    this._checkFilled();

    if (this.validationRules) {
      this._initValidator();
    }
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Forms, [{
    key: "unload",
    value: function unload() {
      this.$el.off('.forms');

      if (this.validator) {
        this.validator.destroy();
      }
    }
  }, {
    key: "_checkFilled",
    value: function _checkFilled() {
      var _this = this;

      this.$el.find(this.fieldSelector).each(function (i, el) {
        if ($(el).hasClass(_this.filledClass)) {
          return;
        }

        _this._toggleFilled(null, el);
      });
    }
  }, {
    key: "_toggleFilled",
    value: function _toggleFilled() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var $el = event ? $(event.currentTarget) : $(el);
      var value = $el.val();
      var isFilled = !!(value && value.length > 0);
      $el.toggleClass(this.filledClass, isFilled);
    }
  }, {
    key: "_initValidator",
    value: function _initValidator() {
      $.validator.messages.max = '';
      $.validator.messages.required = '';
      this.validator = this.$el.validate(this.validationRules);
    }
  }]);

  return Forms;
}();



/***/ })

/******/ });